
import { Select, MenuItem, Checkbox, ListItemText} from "@mui/material";
import { useState } from "react";

const CustomCountryCell = (props) => {
  const {id, api, field, value, isEdit } = props;
  const [selectedValues, setSelectedValues] = useState(value);

  const handleChange = (event) => {
    // Use event.target.value directly
    let newSelectedValues = event.target.value;
    let finalValToSelect = selectedValues; // This should already be an array
    const spainAndPortugal = ["Spain", "Portugal"];
    const irelandPolandUK = ["Ireland", "Poland", "UK"];
  
    let isSpainOrPortugalValChanged = false;
    let isIrelandPolandValChange = false
    
    if(newSelectedValues.includes("Spain") ||  newSelectedValues.includes("Portugal") ) {
        if((finalValToSelect.includes("Spain") &&  finalValToSelect.includes("Portugal")) &&
        newSelectedValues.includes("Spain") &  newSelectedValues.includes("Portugal")) {
          isSpainOrPortugalValChanged = false;
        }else
        {
          isSpainOrPortugalValChanged = true;
        }
    }

    if(newSelectedValues.includes("Ireland") ||  newSelectedValues.includes("Poland") || newSelectedValues.includes("UK")) {
      if((finalValToSelect.includes("Ireland") &&  finalValToSelect.includes("Poland")&&  finalValToSelect.includes("UK"))&&
      newSelectedValues.includes("Ireland") &  newSelectedValues.includes("Poland") & newSelectedValues.includes("UK")) {
        isIrelandPolandValChange = false;
      }else
      {
        isIrelandPolandValChange = true;
      }
  } 
   
    if (isSpainOrPortugalValChanged) {
      // Check if either Spain or Portugal is newly selected
       const isSpainOrPortugalSelected = spainAndPortugal.some(
        (country) =>
          newSelectedValues.includes(country) &&
          !selectedValues.includes(country)
      );
      if (isSpainOrPortugalSelected) {
        // If either Spain or Portugal is newly selected, ensure both are included
        finalValToSelect = [...finalValToSelect, ...spainAndPortugal ]; // Add both
      } else {
        // If both are not newly selected, remove them from the newSelectedValues
        finalValToSelect = finalValToSelect.filter(
          (value) => !spainAndPortugal.includes(value)
        ); // Remove both
      }
    } else if (isIrelandPolandValChange) {
      // Check if any of Ireland, Poland, or UK is newly selected
      const isIrelandPolandUKSelected = irelandPolandUK.some(
        (country) =>
          newSelectedValues.includes(country) &
          !selectedValues.includes(country)
      );
     
      if (isIrelandPolandUKSelected) {
        
        // If any of Ireland, Poland, or UK is newly selected, ensure all three are included
        finalValToSelect = [...finalValToSelect, ...irelandPolandUK]; // Add all
      } else {
        // If none of them are newly selected, remove them from newSelectedValues
        finalValToSelect = finalValToSelect.filter(
          (value) => !irelandPolandUK.includes(value)
        ); // Remove all
      }
    } else {
     
        // If both are not newly selected, remove them from the newSelectedValues
        finalValToSelect = finalValToSelect.filter(
          (value) => !selectedValues.includes(value));
      
        finalValToSelect = [...finalValToSelect, ...newSelectedValues];
      
     
    }    
    setSelectedValues(finalValToSelect);
    api.setEditCellValue({ id, field, value: finalValToSelect });
  };

  return (
    <Select
      multiple
      value={selectedValues}
      onChange={handleChange}
      renderValue={(selected) => selected.join(", ")}
      style={{ width: "100%" }}
    >
      {props.valueOptions.map((option) => (
        <MenuItem key={option} value={option}>
          {isEdit && <Checkbox checked={selectedValues.indexOf(option) > -1} />}
          <ListItemText primary={option} />
        </MenuItem>
      ))}
    </Select>
  );
};

export default CustomCountryCell;
